/************************* Helpers *************************/
let gOverlayLoaded = false;

const createGOverlay = () => {
  const overlay = document.createElement('div');
  //This is for stores that hides empty div's
  overlay.innerHTML = '&nbsp;';
  overlay.classList.add('gtc:overlay')
  document.body.append(overlay)
  gOverlayLoaded = true;
};

window.getPageContentHtml = async (pageUrl) => {
  try {
    // Get page as JSON to get body_html, to inject in modal/ drawer
    const pageJson = await (
      await fetch(pageUrl + '.json')
        .then(res => res.json()));
    if (pageUrl.includes('policies/')) {
      return pageJson.policy.body;
    } else {
      return pageJson.page.body_html;

    }
  } catch (error) {
    console.error('Error: ', error);
    return '';
  }
};

const getSectionHtml = async (section, canonicalUrl) => {
  try {
    let url = window.location.pathname + '/?sections=' + section;
    if (canonicalUrl) {
      url = new URL(canonicalUrl).pathname + '/?sections=' + section;
    }

    // Get page as JSON to get body_html, to inject in modal/ drawer
    const sectionJson = await (
      await fetch(url)
        .then(res => res.json()));
    return sectionJson[section];
  } catch (error) {
    console.error('Error: ', error);
    return '';
  }
};

const getTemplateHtml = async (templateId) => {
  const template = document.getElementById(templateId);
  return template.innerHTML;
}


window.gtcPreviousFocus = null;
function gtcHandleTrapFocus(e) {
  const isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) { // if shift key pressed for shift + tab combination
    if (document.activeElement === this.firstFocusableElement) {
      this.lastFocusableElement.focus(); // add focus for the last focusable element
      e.preventDefault();
    }
  } else { // if tab key is pressed
    if (document.activeElement === this.lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
      this.firstFocusableElement.focus(); // add focus for the first focusable element
      e.preventDefault();
    }
  }
}

window.gtcTrapFocus = (element) => {
  const focusableElements = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

  element.firstFocusableElement = focusableElements[0];
  element.lastFocusableElement = focusableElements[focusableElements.length - 1];

  // Focus the first element initially
  element.firstFocusableElement.focus();

  // Listen for and trap the keyboard
  element.addEventListener('keydown', gtcHandleTrapFocus);
}

window.gtcRemoveTrapFocus = (element) => {
  // Remove the event listener
  element.removeEventListener('keydown', gtcHandleTrapFocus);

  if (gtcPreviousFocus) {
    gtcPreviousFocus.focus();
    gtcPreviousFocus = null;
  }
}

/************************* GTC Opener *************************/

/**
 * GTC Opener
 *
 * Settings: if the opener contains "data-gtc-close" and "this" is click "this" will close
 */

class GTCOpener extends HTMLElement {
  static observedAttributes = ["open"];

  constructor() {
    super()

    //Default classes
    this.class = {
      open: 'open',
      close: 'close',
      overlayOpen: 'gtc:overlay-open',
      scrollLock: 'gtc:scroll-lock'
    }

    this.Click = this.Click.bind(this);
    this.Keydown = this.Keydown.bind(this);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "open") {
      if (newValue !== null) {
        this.Open();
        this.setAttribute('aria-hidden', "false");
      } else {
        this.Close();
        this.setAttribute('aria-hidden', "true");
      }
    }
  }

  get isOpen() {
    return this.getAttribute("open") === "true";
  }
  set isOpen(value) {
    this.setAttribute("open", value ? "true" : "false");
  }


  connectedCallback() {

    // Add accessibility attributes
    this.setAttribute('role', 'dialog');
    this.setAttribute('aria-modal', 'true');
    this.setAttribute('aria-hidden', !this.isOpen);
    this.setAttribute('tabindex', '0');

    this.settings = {
      rendered: false,
      ...JSON.parse(this.getAttribute('settings'))
    };

    //Needs a render to display the content
    switch (this.settings.type) {
      case 'modal':

        // this.render = renderDefaultModal;
        const modalTemplate = document.getElementById('gtc-modal-template');
        const modalContent = modalTemplate.content.children[0];

        // Check if the content is not empty
        if (modalContent) {
          this.render = modalContent;
        }
        break;

      default:
        // this.render = renderDefaultDrawer;
        const drawerTemplate = document.getElementById('gtc-drawer-template');
        const drawerContent = drawerTemplate.content.children[0];

        // Check if the content is not empty
        if (drawerContent) {
          this.render = drawerContent;
        }
        break;
    };
  }

  disconnectedCallback() {
    this.Close();
    this.RemoveOpenerEventListeners();
    this.settings.rendered = false;

    document.getElementById(`Trigger-${ this.settings.id }`) ? document.getElementById(`Trigger-${ this.settings.id }`).removeAttribute('loaded') : null;
  }


  async Init() {
    if (this.settings.rendered === true) {
      this.Open();
    } else {
      await this.Create();
      gtcTrapFocus(this)
    }
  }

  AddOpenerEventListeners() {
    document.addEventListener('click', this.Click, false);
    document.addEventListener("keydown", this.Keydown, false);
  }
  RemoveOpenerEventListeners() {
    document.removeEventListener('click', this.Click, false);
    document.removeEventListener("keydown", this.Keydown, false);
  }

  Click(event) {
    if (!this.hasAttribute(this.class.open)) return
    const target = event.target;

    if (target.classList.contains('gtc:overlay') || !target.closest('nested') && this.contains(target)) {

      // Closes  if clicked outside of the Modal/drawer, or clicking on data-gtc-close
      if (!this.contains(target) || target.hasAttribute('data-gtc-close')) {
        this.Close();
      }
    }
  }

  Keydown(event) {
    // If Esc key
    if (event.keyCode !== 27) return;
    this.Close();
  }

  Open() {
    document.body.classList.add(this.class.overlayOpen, this.class.scrollLock);
    setTimeout(() => {
      this.AddOpenerEventListeners();
      gtcTrapFocus(this);
    }, 0);

  }

  Close() {
    this.removeAttribute(this.class.open);
    if (!this.classList.contains('nested')) {
      document.body.classList.remove(this.class.overlayOpen, this.class.scrollLock);
    }
    setTimeout(() => {
      this.RemoveOpenerEventListeners();
    }, 0);


    gtcRemoveTrapFocus(this);
  }

  async GetData() {

    this.data = {};

    const keys = Object.keys(this.settings?.slots);
    for (const key of keys) {
      const content = await this.GetContent(this.settings.slots[key]);

      if (!content) continue;
      this.data = {
        ...this.data,
        [key]: content
      };
    }
  }

  async GetContent(contentArray) {

    if (contentArray) {
      switch (contentArray[0]) {
        case 'string':
          return contentArray[1];
        case 'template':
          return await getTemplateHtml(contentArray[1]);
        case 'url':
          return await getPageContentHtml(contentArray[1]);
        case 'section':
          const canonicalUrl = this.settings.canonicalUrl ? this.settings.canonicalUrl : null;
          return await getSectionHtml(contentArray[1], canonicalUrl);
        case 'tabs':
          return await this.GetContentTabs(contentArray[1]);
        case 'extraLink':
          return await this.GetContentExtraLink(contentArray[1]);
        default:
          return '';
      }
    }
  }

  async Create() {

    await this.GetData();

    this.render.querySelectorAll('[slot]').forEach((slot) => {
      const slotName = slot.getAttribute('slot');

      if (this.data[slotName]) {
        slot.innerHTML = this.data[slotName] || '';
      } else {
        slot.remove();
      }
    });

    if (!this.render.innerHTML) return console.warn('No HTML IN GTC-OPENER!');

    if (!gOverlayLoaded) {
      createGOverlay();
    }

    if (this.settings?.class) {
      const classes = this.settings.class.split(' ').filter((letter) => letter !== "");;
      this.classList.add(...classes)
    }

    if (this.settings?.id) {
      this.setAttribute('id', `Opener-${ this.settings.id }`);
    }

    this.insertAdjacentHTML('beforeend', this.render.innerHTML);

    //This forces repaint
    void this.offsetHeight;

    this.settings.rendered = true

    this.setAttribute(this.class.open, '');

    document.addEventListener(`gtc:opener:open.${ this.settings.id }`, () => {
      this.setAttribute(this.class.open, '')
    });
  }

}

/************************* GTC Modal *************************/
class GTCModal extends GTCOpener {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.Init();
  }
}

customElements.define('gtc-modal', GTCModal);

/************************* GTC Drawer *************************/

class GTCDrawer extends GTCOpener {

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.Init();
  }
}
customElements.define('gtc-drawer', GTCDrawer);

/************************* GTC Trigger *************************/


class GTCTrigger extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.hasAttribute('tabindex')) {
      // Choose one of the following lines (but not both):
      this.setAttribute('tabindex', 0);
      this.tabIndex = 0;
    }

    this.Init();
  }

  disconnectedCallback() {
    this.RremoveEventListeners();
  }

  AddEventListeners() {
    this.Click = this.Click.bind(this);

    this.addEventListener('focus', () => this.classList.add('focus'));
    this.addEventListener('blur', () => this.classList.remove('focus'));
    this.addEventListener('click', this.Click);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        this.Click();
      }
    }, false);
  }

  RremoveEventListeners() {
    this.removeEventListener('focus', () => this.classList.add('focus'));
    this.removeEventListener('blur', () => this.classList.remove('focus'));
    this.removeEventListener('click', this.Click);
    this.removeEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        this.Click();
      }
    }, false);
  }

  Init() {
    const settings = this.hasAttribute('settings') ? { ...JSON.parse(this.getAttribute('settings')) } : null;

    if (!settings) {
      console.error('No settings found on gtc-trigger')
      return;
    }

    this.settings = {
      ...settings
    };

    this.AddEventListeners();
  }

  Click() {
    gtcPreviousFocus = this;
    if (!this.hasAttribute('loaded')) {

      switch (this.settings.type) {
        case 'modal':
          this.CreateCustomElement(this.settings.type)
          break;
        case 'drawer':
          this.CreateCustomElement(this.settings.type)
          break;
        default:
          console.warn('No opener "type" is matching.');
          this.setAttribute('disabled', '');
          break;
      }
      this.setAttribute('loaded', '');
    }
    else {
      document.dispatchEvent(new CustomEvent(`gtc:opener:open.${ this.settings.id }`));
    }
  }

  CreateCustomElement(type) {
    const openerElement = document.createElement(`gtc-${ type }`);
    openerElement.setAttribute('settings', JSON.stringify(this.settings));
    openerElement.classList.add(`gtc:${ type }`);
    document.body.append(openerElement)
  }
}

customElements.define('gtc-trigger', GTCTrigger);